import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

import { SeoService, SeoData } from '../seo/seo.service';

@Injectable({ providedIn: 'root' })
export class SeoRouterListenerService {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private seo: SeoService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  init(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    // set SEO anche al primo load
    queueMicrotask(() => this.applySeoFromCurrentRoute());

    // set SEO ad ogni navigazione
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => this.applySeoFromCurrentRoute());
  }

  private applySeoFromCurrentRoute(): void {
    const seoData = this.getDeepestSeoData(this.route);
    if (seoData) this.seo.updateTags(seoData);
  }

  private getDeepestSeoData(route: ActivatedRoute): SeoData | null {
    let current: ActivatedRoute | null = route;
    while (current?.firstChild) current = current.firstChild;
    return (current?.snapshot?.data?.['seo'] as SeoData) || null;
  }
}
